import type {
  AttachmentRequest,
  GetAttachmentListRequest,
  GetListResponseOfAttachmentSimpleResponse,
  GetListResponseOfUserRelatedAttachmentResponse,
  GetUserRelatedAttachmentsRequest,
} from 'src/api/ProactApiClient';
import {attachmentApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export interface DeleteAttachmentRequest {
  id: number;
  entityId: number;
}

export const attachmentApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAttachmentList: builder.query<
      GetListResponseOfAttachmentSimpleResponse,
      GetAttachmentListRequest
    >({
      queryFn: clientQuery(params => attachmentApiClient.list(params)),
      providesTags: ['Attachments'],
    }),
    getUserRelatedAttachments: builder.query<
      GetListResponseOfUserRelatedAttachmentResponse,
      GetUserRelatedAttachmentsRequest
    >({
      queryFn: clientQuery(params => attachmentApiClient.listForUser(params)),
      providesTags: ['Attachments'],
    }),
    createAttachment: builder.mutation<boolean, AttachmentRequest>({
      queryFn: clientQuery(request => attachmentApiClient.create(request)),
      invalidatesTags: ['Attachments'],
    }),
    updateAttachment: builder.mutation<boolean, AttachmentRequest>({
      queryFn: clientQuery(request => attachmentApiClient.update(request)),
      invalidatesTags: ['Attachments'],
    }),
    deleteAttachment: builder.mutation<void, DeleteAttachmentRequest>({
      queryFn: voidClientQuery(({id, entityId}) =>
        attachmentApiClient.delete(id, entityId)
      ),
      invalidatesTags: ['Attachments'],
    }),
  }),
});

export const {
  useGetAttachmentListQuery,
  useGetUserRelatedAttachmentsQuery,
  useCreateAttachmentMutation,
  useUpdateAttachmentMutation,
  useDeleteAttachmentMutation,
} = attachmentApi;
